import { DialogBranch, DialogModule, DialogStep } from '@storyverseco/svs-dialog-ruleset';
import { DialogLike } from '../types';

/**
 * This migration got introduced because we have dead data lingering around. This causes validation to fail.
 */
export const migrateCleanUpCamera = async (dialog: DialogLike): Promise<DialogModule> => {
  const branch = dialog.scenes.scene1.branches.start as DialogBranch;

  branch.steps.forEach((step) => {
    const anyStep = step as any;
    if (step.camera) {
      delete anyStep.camera.layout;
      delete anyStep.camera.mode;
    }
    step = anyStep;
  });

  return dialog;
};
